import React from "react";

const Design = () => {
  return (
    <div className="design">
      <h1 class="home-title">
        <span>&nbsp;&nbsp;It isn't about what you know&nbsp;&nbsp;</span>
        <span>&nbsp;&nbsp;Its about what you can figure out&nbsp;&nbsp;</span>
      </h1>
    </div>
  );
};

export default Design;
